// Generated file : do not modify
import { ObjTypes } from '@/generated/classes/ObjTypes';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import ListData from '@/extend/classes/ListData';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Routage vers un module un fiche ou une section
export class PdfNotif {
  // Type du document PDF
  public objType: ObjTypes;
  // ID du document PDF
  public objId: number;

  constructor() {
    this.objType = ObjTypes.NONE;
    this.objId = 0;
  }
}

export default class Route  {
  // ID to manage stack of routes
  public id: number;
  // Module associé à la notification
  public module: string;
  // Fiche associé à la notification
  public fiche: string;
  // Fiche associé à la notification
  public ficheHeader: string;
  // item de la fiche si c'est une liste
  public ficheObjId: number | null;
  // Section associé à la notification
  public section: string;
  // item de la section si c'est une liste
  public sectionObjId: number;
  // Attribut auquel le focus doit être donné ou objet passé au dialogue
  public attribut: unknown;
  // Notification issue d'une URL de document
  public pdfNotif: PdfNotif;
  // Ouvrir la section en dialog
  public isDialog: boolean;
  // Data de la route
  public data: unknown;
  // Updated
  public updated: boolean;
  // Error
  public error: boolean;
  // Required missing
  public missing: boolean;
  // Attributs requis sous forme SECTION.KEY
  public requiredAttributs: string[];

  constructor() {
    this.id = 0;
    this.module = '';
    this.fiche = '';
    this.ficheHeader = '';
    this.ficheObjId = null;
    this.section = '';
    this.sectionObjId = 0;
    this.attribut = null;
    this.pdfNotif = new PdfNotif();
    this.isDialog = false;
    this.data = null;
    this.updated = false;
    this.error = false;
    this.missing = false;
    this.requiredAttributs = [];
  }

  public static fromJson (obj: Route): Route {
    const newRoute: Route = new Route();
    newRoute.id = obj.id;
    newRoute.module = obj.module;
    newRoute.fiche = obj.fiche;
    newRoute.ficheHeader = obj.ficheHeader;
    newRoute.ficheObjId = obj.ficheObjId;
    newRoute.section = obj.section;
    newRoute.sectionObjId = obj.sectionObjId;
    newRoute.attribut = obj.attribut;
    newRoute.pdfNotif = JSON.parse(JSON.stringify(obj.pdfNotif));
    newRoute.isDialog = obj.isDialog;
    newRoute.data = obj.data;
    newRoute.updated = obj.updated;
    newRoute.error = obj.error;
    newRoute.missing = obj.missing;
    newRoute.requiredAttributs = JSON.parse(JSON.stringify(obj.requiredAttributs));
    return newRoute;
  }

  public toJsonRoute (): string {
    const json = {
      id: this.id,
      module: this.module,
      fiche: this.fiche,
      ficheHeader: this.ficheHeader,
      ficheObjId: this.ficheObjId,
      section: this.section,
      sectionObjId: this.sectionObjId,
      attribut: this.attribut,
      pdfNotif: this.pdfNotif,
      isDialog: this.isDialog,
      data: this.data,
      updated: this.updated,
      error: this.error,
      missing: this.missing,
      requiredAttributs: this.requiredAttributs,
    }
    return JSON.stringify(json);
  }

  public fromRoute (obj: Route): void {
    this.id = obj.id;
    this.module = obj.module;
    this.fiche = obj.fiche;
    this.ficheHeader = obj.ficheHeader;
    this.ficheObjId = obj.ficheObjId;
    this.section = obj.section;
    this.sectionObjId = obj.sectionObjId;
    this.attribut = obj.attribut;
    this.pdfNotif = obj.pdfNotif;
    this.isDialog = obj.isDialog;
    this.data = obj.data;
    this.updated = obj.updated;
    this.error = obj.error;
    this.missing = obj.missing;
    this.requiredAttributs = obj.requiredAttributs;
  }

  public compareRoute (value: Route): boolean {
    return (this.toJsonRoute() == value.toJsonRoute());
  }

  public cloneRoute (): Route {
    return Route.fromJson(this);
  }

  public static closeSection (section: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/routes/closeSection/' + section, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(routes: Route[]) {
  }
}
